export const places = [
  { "Achaea department": { coords: [21.7325700000001, 38.24424], code: "" } },
  { Acilia: { coords: [12.3651100000001, 41.7834], code: "" } },
  { Aegina: { coords: [8.31667000000004, 46.5000000000001], code: "" } },
  { Agrigentum: { coords: [13.58876, 37.32084], code: "" } },
  { Alexandria: { coords: [29.9125300000001, 31.2105], code: "eg" } },
  { Anatolia: { coords: [35.0000000000001, 39.0000000000001], code: "" } },
  { "Ancient Egypt": { coords: [31.2486000000001, 30.04992], code: "" } },
  { "Ancient Greece": { coords: [23.7364000000001, 37.97614], code: "" } },
  { "Ancient Mediterranean": { coords: [35.6, 32.8], code: "" } },
  { "Ancient Near East": { coords: [35.6, 32.8], code: "" } },
  {
    "Andhra Pradesh": {
      coords: [77.7500000000001, 20.9333300000001],
      code: "",
    },
  },
  { Antioch: { coords: [36.15873, 36.20338], code: "" } },
  { Apulia: { coords: [16.618785524, 40.985041052], code: "" } },
  { Arizona: { coords: [-111.664753988, 34.293016451], code: "us" } },
  { Arkansas: { coords: [-92.4388847, 34.8999237250001], code: "us" } },
  { Arsinoë: { coords: [30.8418, 29.3099500000001], code: "" } },
  { Athens: { coords: [23.7364000000001, 37.97614], code: "gr" } },
  { Attica: { coords: [23.9035000000001, 37.92037], code: "gr" } },
  { Austria: { coords: [14.1370769480001, 47.585810005], code: "at" } },
  { Baccarat: { coords: [6.74011000000007, 48.45021], code: "fr" } },
  { Baltimore: { coords: [-76.6092599999999, 39.29058], code: "us" } },
  { Bangladesh: { coords: [90.2884539010001, 23.804670475], code: "bd" } },
  { Barce: { coords: [22.1240700000001, 50.5108900000001], code: "" } },
  { Basilicata: { coords: [16.0815521810001, 40.4999693030001], code: "" } },
  { Belgium: { coords: [4.66107042700003, 50.6406829370001], code: "be" } },
  { Bhutan: { coords: [90.4262309850001, 27.4148268270001], code: "bt" } },
  { Bihar: { coords: [85.4872800000001, 25.15146], code: "" } },
  { Birmingham: { coords: [-1.90591999999998, 52.47891], code: "gb" } },
  { Bohemia: { coords: [14.4330200000001, 50.0791300000001], code: "cz" } },
  { Bolivia: { coords: [-64.597494028, -16.670855662], code: "bo" } },
  { Borneo: { coords: [-79.1333299999999, -0.249999999999943], code: "" } },
  { Boston: { coords: [-71.0567399999999, 42.35866], code: "us" } },
  { Bow: { coords: [-0.127209999999934, 51.50642], code: "gb" } },
  { Bristol: { coords: [-2.59167999999994, 51.45379], code: "gb" } },
  { Brooklyn: { coords: [-73.99036, 40.6924500000001], code: "us" } },
  { Brunswick: { coords: [10.5274000000001, 52.2654400000001], code: "de" } },
  { Brussels: { coords: [4.35609000000005, 50.84439], code: "be" } },
  { Buffalo: { coords: [-78.87846, 42.8854400000001], code: "us" } },
  { Burma: { coords: [96.5117787670001, 21.1208468140001], code: "mm" } },
  { Burslem: { coords: [-2.18419999999998, 53.0542500000001], code: "gb" } },
  {
    "Byzantine Empire": {
      coords: [28.9496600000001, 41.0138400000001],
      code: "tr",
    },
  },
  { Cales: { coords: [0.812290000000075, 44.8558800000001], code: "" } },
  { California: { coords: [-119.27023, 36.374105693], code: "us" } },
  { Cambodia: { coords: [104.914716152, 12.7081885070001], code: "kh" } },
  { Campeche: { coords: [-90.4, 18.833333], code: "mx" } },
  { Capua: { coords: [14.20881, 41.1078800000001], code: "it" } },
  { Carthage: { coords: [10.3233, 36.8528], code: "" } },
  { Caucasus: { coords: [44.121111, 42.261111], code: "" } },
  { "Central Anatolian Region": { coords: [33, 39], code: "" } },
  { "Central Asia": { coords: [59.175252936, 39.193358184], code: "tm" } },
  { "Central California": { coords: [-119.44944, 37.16611], code: "us" } },
  {
    "Central Coast": {
      coords: [-77.2688899999999, -11.5708099999999],
      code: "pe",
    },
  },
  { "Central Europe": { coords: [28.8, 55.483333], code: "" } },
  { "Central Italy": { coords: [12.3839100000001, 43.11136], code: "it" } },
  { "Central Java": { coords: [110.004444, -7.491667], code: "id" } },
  {
    "Central Mexico": {
      coords: [-102.548353419, 23.9528249900001],
      code: "mx",
    },
  },
  {
    "Central Tibet": { coords: [90.0000000000001, 32.0000000000001], code: "" },
  },
  { "Chavín de Huantar": { coords: [-77.178333, -9.592778], code: "pe" } },
  { Chelsea: { coords: [-0.162479999999959, 51.4901400000001], code: "gb" } },
  {
    "Chicama River Valley": {
      coords: [-79.02278, -8.11596999999995],
      code: "pe",
    },
  },
  { China: { coords: [104.1953964, 35.86166], code: "cn" } },
  { "China, northern": { coords: [112, 37.0000000000001], code: "cn" } },
  { "Chipping Campden": { coords: [-1.779, 52.052], code: "gb" } },
  { Cholula: { coords: [-98.31, 9.06], code: "mx" } },
  { Chupícuaro: { coords: [-100.591389, 20.022222], code: "" } },
  { Cincinnati: { coords: [-84.516667, 39.1], code: "us" } },
  { Clichy: { coords: [2.31, 48.9], code: "fr" } },
  { Colima: { coords: [-103.724722, 19.243333], code: "mx" } },
  { "Colima state": { coords: [-103.724722, 19.243333], code: "mx" } },
  { Cologne: { coords: [6.95516000000003, 50.94167], code: "de" } },
  { Colombia: { coords: [-73.075754924, 3.90111580400003], code: "co" } },
  { Connecticut: { coords: [-72.738305908, 41.57350273], code: "us" } },
  {
    Constantinople: { coords: [28.9496600000001, 41.0138400000001], code: "" },
  },
  { Corinth: { coords: [22.933333, 37.933333], code: "" } },
  { Cork: { coords: [-8.47, 51.897222], code: "ie" } },
  { Corona: { coords: [-73.866667, 40.75], code: "us" } },
  { "Costa Rica": { coords: [-84.196318439, 9.97283717900007], code: "cr" } },
  { Crotone: { coords: [17.12292, 39.0812500000001], code: "it" } },
  { Cuzco: { coords: [-76.46667, -6.98332999999997], code: "pe" } },
  { Cyprus: { coords: [33.2262297740001, 35.0501742590001], code: "cy" } },
  { Cyrene: { coords: [21.858056, 32.825], code: "" } },
  { "Czech Republic": { coords: [15.33177012, 49.73885405], code: "cz" } },
  { Deccan: { coords: [120.5136, 16.7698], code: "" } },
  { Delft: { coords: [4.36534000000006, 52.0087800000001], code: "nl" } },
  {
    "Democratic Republic of Congo": {
      coords: [23.615704764, -2.86218500399997],
      code: "cd",
    },
  },
  {
    "Democratic Republic of the Congo": {
      coords: [23.615704764, -2.86218500399997],
      code: "cd",
    },
  },
  { Denmark: { coords: [10.053934054, 55.9593007790001], code: "dk" } },
  { Deruta: { coords: [12.41966, 42.9860400000001], code: "it" } },
  { Dodona: { coords: [0.74126714700003, 45.1049000790001], code: "" } },
  { Dresden: { coords: [13.7408100000001, 51.0536300000001], code: "de" } },
  { Dublin: { coords: [-6.24826999999993, 53.3480700000001], code: "ie" } },
  { "Eastern Java": { coords: [112.750446, -7.252455], code: "id" } },
  {
    "Eastern Mediterranean Region": {
      coords: [35.20016, 33.2705700000001],
      code: "",
    },
  },
  { Ecuador: { coords: [-78.775238552, -1.42883629099993], code: "ec" } },
  { Egypt: { coords: [29.8704948600001, 26.5122734930001], code: "eg" } },
  { "El Tajín": { coords: [-97.3355799999999, 20.44447], code: "" } },
  { Etruria: { coords: [-63.2439699999999, -32.93947], code: "" } },
  { Eurasia: { coords: [-56.28333, -21.5666699999999], code: "" } },
  { Europe: { coords: [28.8, 55.483333], code: "" } },
  {
    "Europe, southern": {
      coords: [9.18178000000006, 45.4679600000001],
      code: "",
    },
  },
  { Flanders: { coords: [4.5, 51], code: "be" } },
  { "Flecken Zechlin": { coords: [12.8913200000001, 53.10028], code: "de" } },
  { Florence: { coords: [11.25501, 43.7823700000001], code: "it" } },
  { France: { coords: [2.213749, 46.227638], code: "fr" } },
  { Frankenthal: { coords: [8.35066000000006, 49.5348300000001], code: "de" } },
  {
    "Frankfurt an der Oder": {
      coords: [14.5542800000001, 52.3417000000001],
      code: "de",
    },
  },
  { French: { coords: [2.55053995300005, 46.559417044], code: "fr" } },
  { Gandhara: { coords: [84.5541600000001, 24.7763200000001], code: "" } },
  { Gela: { coords: [14.2502200000001, 37.06816], code: "it" } },
  { "Germany, southern": { coords: [11.593326, 48.14658], code: "de" } },
  { Glasgow: { coords: [-4.24250999999992, 55.85783], code: "gb-sct" } },
  { "Greater Athens": { coords: [23.7364000000001, 37.97614], code: "gr" } },
  { Greece: { coords: [22.0000000000001, 39.0000000000001], code: "gr" } },
  { "Guanajuato state": { coords: [-101.266667, 21.016667], code: "mx" } },
  { Guatemala: { coords: [-90.3639794599999, 15.697237961], code: "gt" } },
  { Guerrero: { coords: [-107.48667, 28.5480400000001], code: "mx" } },
  { Holland: { coords: [5.55, 52.316667], code: "nl" } },
  { Hungary: { coords: [19.4245317, 47.1670887700001], code: "hu" } },
  { "Ica Valley": { coords: [-75.73022, -14.0638299999999], code: "pe" } },
  { Illinois: { coords: [-89.158650902, 40.11404657], code: "us" } },
  { Illyria: { coords: [14.258333, 40.845], code: "" } },
  { India: { coords: [79.4433265480001, 23.379379735], code: "in" } },
  { "India, eastern": { coords: [88.383241, 22.554053], code: "in" } },
  { Indiana: { coords: [-86.2817934879999, 39.919806964], code: "us" } },
  { Indonesia: { coords: [113.915865, -0.989818181999965], code: "id" } },
  { Ionia: { coords: [-85.0641899999999, 42.9831], code: "" } },
  { "Iran, northwestern": { coords: [46.290283, 38.093796], code: "ir" } },
  { Ireland: { coords: [-8.14600614699998, 53.175879846], code: "ie" } },
  { Isfahan: { coords: [51.6776100000001, 32.6572200000001], code: "ir" } },
  { Ismir: { coords: [27.13838, 38.4127300000001], code: "tr" } },
  { Israel: { coords: [34.9792176920001, 31.977711512], code: "il" } },
  { Istanbul: { coords: [28.9496600000001, 41.0138400000001], code: "tr" } },
  { Italian: { coords: [12, 43], code: "it" } },
  { Italy: { coords: [12, 43], code: "it" } },
  { "Italy, central": { coords: [12.3839100000001, 43.11136], code: "it" } },
  { Izmir: { coords: [27.1418800000001, 38.4262000000001], code: "tr" } },
  { "Jalisco state": { coords: [-103.683333, 20.566667], code: "mx" } },
  { Japan: { coords: [139.271495, 36.6552269980001], code: "jp" } },
  { Java: { coords: [110.004444, -7.491667], code: "id" } },
  {
    "Jerusalem, Latin Kingdom of": {
      coords: [35.2187300000001, 31.7800300000001],
      code: "il",
    },
  },
  { Jingdezhen: { coords: [117.20789, 29.2947], code: "cn" } },
  { Junyao: { coords: [104.1953964, 35.86166], code: "cn" } },
  { Karnataka: { coords: [76.170469467, 14.705918599], code: "in" } },
  { Kashmir: { coords: [76.6666700000001, 33.9166700000001], code: "" } },
  { Kazakhstan: { coords: [71.433333, 51.166667], code: "kz" } },
  { "Kathmandu Valley": { coords: [85.308611, 27.703889], code: "np" } },
  { Kéa: { coords: [24.307398, 37.618285], code: "gr" } },
  { Khorasan: { coords: [86.6722800000001, 25.6927900000001], code: "" } },
  { Knidos: { coords: [-99.64726, 25.38528], code: "" } },
  { Knossos: { coords: [24.8225800000001, 41.0455000000001], code: "" } },
  { Kodumbalur: { coords: [78.51174, 10.54024], code: "in" } },
  { Korea: { coords: [127.233333, 38.316667], code: "" } },
  { "Korean Peninsula": { coords: [127.233333, 38.316667], code: "" } },
  {
    "La Salle Street, 209 South": {
      coords: [-87.631824, 41.879313],
      code: "us",
    },
  },
  { Lahore: { coords: [74.3436100000001, 31.54972], code: "pk" } },
  { Lárisa: { coords: [22.42134, 39.63852], code: "" } },
  { Lauenstein: { coords: [11.3716900000001, 50.5094], code: "" } },
  { Levant: { coords: [35.20016, 33.2705700000001], code: "" } },
  { Levkás: { coords: [22.3833300000001, 36.6166700000001], code: "" } },
  { Liège: { coords: [5.57250000000005, 50.6454900000001], code: "be" } },
  { London: { coords: [-0.127209999999934, 51.50642], code: "gb" } },
  {
    "Los Santos, Provincia de": { coords: [-80.416667, 7.933333], code: "pa" },
  },
  { Lucca: { coords: [10.5153100000001, 43.84198], code: "it" } },
  { Lunéville: { coords: [6.50000000000006, 48.6000000000001], code: "fr" } },
  { Lyon: { coords: [4.82886000000002, 45.7594300000001], code: "fr" } },
  { Macedonia: { coords: [21.7152330820001, 41.610468113], code: "" } },
  {
    "Madhya Pradesh": {
      coords: [78.2975446570001, 23.5430021440001],
      code: "in",
    },
  },
  { "Madison Street, 78-84 West": { coords: [-87.6288, 41.8818], code: "us" } },
  {
    "Madison Street, 29 East": { coords: [-87.626389, 41.881111], code: "us" },
  },
  { Mainz: { coords: [8.27241000000004, 50.00062], code: "de" } },
  { Malaysia: { coords: [112.5, 2.50000000000006], code: "my" } },
  { Mali: { coords: [-3.52047166299997, 17.3629728830001], code: "ml" } },
  { Malta: { coords: [14.40007259, 35.922548856], code: "mt" } },
  { Manises: { coords: [-0.461569999999938, 39.49235], code: "es" } },
  { Mantíneia: { coords: [22.4025, 37.60814], code: "" } },
  { Mantua: { coords: [-81.223056, 41.283611], code: "us" } },
  { "Masr al-`Atiqah": { coords: [31.2486000000001, 30.04992], code: "eg" } },
  {
    Massachusetts: {
      coords: [-71.7181849999999, 42.3586703240001],
      code: "us",
    },
  },
  { Mathura: { coords: [77.6741900000001, 27.49186], code: "in" } },
  { "Mediterranean Region": { coords: [35.6, 32.8], code: "" } },
  { Megalópolis: { coords: [22.1422200000001, 37.4011100000001], code: "" } },
  { Meissen: { coords: [13.4726400000001, 51.1646000000001], code: "de" } },
  { Mesopotamia: { coords: [43.4837, 34.5338], code: "" } },
  { Messina: { coords: [15.55308, 38.17837], code: "it" } },
  { Metapontum: { coords: [16.80978, 40.3710400000001], code: "" } },
  { Meuse: { coords: [5.38141938500007, 48.991096745], code: "" } },
  { Mexico: { coords: [-102.548353419, 23.9528249900001], code: "mx" } },
  { México: { coords: [-102.548353419, 23.9528249900001], code: "mx" } },
  { "Mexico, western": { coords: [-103.683333, 20.566667], code: "mx" } },
  { Michigan: { coords: [-84.1966975, 44.1251998340001], code: "us" } },
  {
    "Michigan Avenue at 24th Street": {
      coords: [-87.623875, 41.849852],
      code: "us",
    },
  },
  { Michoacán: { coords: [-101.882882904, 19.204403085], code: "mx" } },
  { "Middle East": { coords: [41, 29], code: "" } },
  { Midwest: { coords: [-87.533027, 40.773236], code: "us" } },
  { Milan: { coords: [9.18178000000006, 45.4679600000001], code: "it" } },
  { "Moche Valley": { coords: [-79.02278, -8.11596999999995], code: "pe" } },
  { Mongolia: { coords: [103.067633131, 46.8346914740001], code: "mn" } },
  { Morocco: { coords: [-4.99999999999994, 32.0000000000001], code: "ma" } },
  { Moscow: { coords: [37.6150200000001, 55.75696], code: "ru" } },
  { Munster: { coords: [7.13154000000003, 48.0419400000001], code: "fr" } },
  { Mysia: { coords: [143.76667, -36.2499999999999], code: "au" } },
  {
    Nagapattinam: { coords: [79.8406200000001, 10.7769000000001], code: "in" },
  },
  { Nantes: { coords: [-1.55305999999996, 47.2181100000001], code: "fr" } },
  { Naples: { coords: [14.258333, 40.845], code: "it" } },
  { Nayarit: { coords: [-105.233333, 21.75], code: "mx" } },
  { "Nayarit state": { coords: [-105.233333, 21.75], code: "mx" } },
  { "Nazca Valley": { coords: [-74.943611, -14.828889], code: "pe" } },
  { Neapolis: { coords: [35.2544400000001, 32.2211100000001], code: "" } },
  { Nepal: { coords: [83.944163469, 28.2591377030001], code: "np" } },
  { Netherlandish: { coords: [5.55, 52.316667], code: "nl" } },
  { Netherlands: { coords: [5.55, 52.316667], code: "nl" } },
  { "New Bedford": { coords: [-70.93089, 41.6378], code: "us" } },
  { "New Brunswick": { coords: [-66.075149655, 46.634187415], code: "ca" } },
  { "New England": { coords: [-71, 44], code: "us" } },
  { "New Hampshire": { coords: [-71.577596738, 43.685525247], code: "us" } },
  { "New Jersey": { coords: [-74.7285649999999, 39.613348353], code: "us" } },
  { "New London": { coords: [-72.09626, 41.3565], code: "us" } },
  { "New Mexico": { coords: [-106.108403845, 34.4213265340001], code: "us" } },
  { "New York City": { coords: [-74.0071399999999, 40.71455], code: "us" } },
  { Newark: { coords: [-74.17421, 40.73197], code: "us" } },
  { "Newcastle-upon-Tyne": { coords: [-1.6578, 55.0077], code: "gb" } },
  { Newport: { coords: [-71.31089, 41.49256], code: "us" } },
  { Nicoya: { coords: [-85.4499499999999, 10.1438000000001], code: "cr" } },
  { Nievería: { coords: [-76.91667, -11.98333], code: "" } },
  { Nigeria: { coords: [8.10677782800008, 9.59369688200007], code: "ng" } },
  { Nimrud: { coords: [43.328889, 36.098056], code: "" } },
  { Nola: { coords: [14.5275, 40.926111], code: "it" } },
  { "North Africa": { coords: [9.512359, 30.250315], code: "" } },
  {
    "North Carolina": { coords: [-79.185417913, 35.5393443350001], code: "us" },
  },
  { "North Coast": { coords: [-79.02278, -8.11596999999995], code: "pe" } },
  { "Northern Europe": { coords: [6.95516000000003, 50.94167], code: "" } },
  { "Northern Peru": { coords: [-79.02278, -8.11596999999995], code: "pe" } },
  { "Northwest Coast": { coords: [-79.02278, -8.11596999999995], code: "pe" } },
  { Norwich: { coords: [1.29490000000004, 52.6225000000001], code: "gb" } },
  { Nuremberg: { coords: [11.07349, 49.4543400000001], code: "de" } },
  { Oaxaca: { coords: [-96.7261, 17.0617300000001], code: "mx" } },
  { Ocucaje: { coords: [-75.67714, -14.34306], code: "pe" } },
  { Ohio: { coords: [-82.7112151859999, 40.4130567990001], code: "us" } },
  { Oklahoma: { coords: [-97.5085993609999, 35.5826839500001], code: "us" } },
  { "Ometepe, Isla de": { coords: [-85.583333, 11.5], code: "ni" } },
  { Pakistan: { coords: [70.2101036390001, 30.3142829990001], code: "pk" } },
  { Palestine: { coords: [35.2046840570001, 31.9127197870001], code: "" } },
  { Panama: { coords: [-79.9729261369999, 8.93960446000006], code: "pa" } },
  { Pátmos: { coords: [26.5440600000001, 37.3235500000001], code: "gr" } },
  { Peru: { coords: [-75.9999999999999, -9.99999999999994], code: "pe" } },
  { "Peru, southern": { coords: [-75.73022, -14.0638299999999], code: "pe" } },
  {
    "Peruvian Central Coast": {
      coords: [-77.2688899999999, -11.5708099999999],
      code: "pe",
    },
  },
  {
    "Peruvian North Coast": {
      coords: [-79.02278, -8.11596999999995],
      code: "pe",
    },
  },
  {
    "Peruvian South Coast": {
      coords: [-75.73022, -14.0638299999999],
      code: "pe",
    },
  },
  { Petén: { coords: [-90.28333, 14.6166700000001], code: "" } },
  { Philadelphia: { coords: [-75.16218, 39.9522200000001], code: "us" } },
  { Philippines: { coords: [120.86163, 14.1648627970001], code: "ph" } },
  { Pittsburgh: { coords: [-79.99734, 40.4385100000001], code: "us" } },
  { Poland: { coords: [19.3987689860001, 52.1237901540001], code: "pl" } },
  { Portugal: { coords: [-8.51981298999993, 39.593139046], code: "pt" } },
  { Potsdam: { coords: [13.04783, 52.3996100000001], code: "de" } },
  { Puebla: { coords: [-98.31, 9.06], code: "mx" } },
  { Puglia: { coords: [16.618785524, 40.985041052], code: "it" } },
  { Rajasthan: { coords: [73.8457445120001, 26.5865020900001], code: "in" } },
  {
    "Randolph Street, 64 West": { coords: [-87.630495, 41.884589], code: "us" },
  },
  { Ravenna: { coords: [12.20406, 44.4117600000001], code: "it" } },
  { "Reggio di Calabria": { coords: [15.65175, 38.11274], code: "it" } },
  { Remojadas: { coords: [-96.3888699999999, 19.07998], code: "" } },
  { Rhineland: { coords: [7.606, 50.3645], code: "de" } },
  { "Rhode Island": { coords: [-71.4543194669999, 41.48871294], code: "us" } },
  { Rhodes: { coords: [28.2256800000001, 36.44813], code: "" } },
  { "Roman Empire": { coords: [12.4956500000001, 41.90322], code: "" } },
  { Rome: { coords: [12.4956500000001, 41.90322], code: "it" } },
  { Rouen: { coords: [1.08940000000007, 49.44014], code: "fr" } },
  { Russia: { coords: [96.8053715340001, 61.9895261830001], code: "ru" } },
  {
    "Russian Central Asia": {
      coords: [68.0500000000001, 38.5833300000001],
      code: "uz",
    },
  },
  { "Saint-Cloud": { coords: [-94.1975199999999, 45.56586], code: "us" } },
  { "Saint-Louis": { coords: [-90.19956, 38.62775], code: "us" } },
  { Sakkara: { coords: [31.216389, 29.871111], code: "eg" } },
  { Salonika: { coords: [22.9438900000001, 40.6402800000001], code: "" } },
  { Samnium: { coords: [14.8071400000001, 41.35389], code: "" } },
  { Samos: { coords: [-7.32671999999997, 42.7307300000001], code: "gr" } },
  { Sandwich: { coords: [-70.5067799999999, 41.76532], code: "us" } },
  { "Santa Valley": { coords: [-77.116667, -9.266667], code: "pe" } },
  { Saqqara: { coords: [31.216389, 29.871111], code: "eg" } },
  { "Saratoga Springs": { coords: [-73.78441, 43.0841100000001], code: "us" } },
  { Sardegna: { coords: [9.03048771600004, 40.0878010210001], code: "it" } },
  { Saxony: { coords: [13.358889, 51.026944], code: "de" } },
  { Schleswig: { coords: [9.56647000000004, 54.51586], code: "de" } },
  { Selinunte: { coords: [78.1186000000001, 13.03502], code: "it" } },
  { Seville: { coords: [-6.00195999999994, 37.3878800000001], code: "es" } },
  { Sèvres: { coords: [2.21194000000003, 48.8243600000001], code: "fr" } },
  { Shanxi: { coords: [112, 37.0000000000001], code: "cn" } },
  { Sikión: { coords: [86.20392, 26.8055200000001], code: "" } },
  { "South Asia": { coords: [73.867843, 30.990641], code: "" } },
  { "South Coast": { coords: [-75.73022, -14.0638299999999], code: "pe" } },
  { "South Korea": { coords: [127.806395933, 36.356270963], code: "kr" } },
  { "Southern Germany": { coords: [11.593326, 48.14658], code: "de" } },
  { "Southern Italy": { coords: [14.258333, 40.845], code: "it" } },
  { "Southern Tibet": { coords: [87.958267, 28.611581], code: "" } },
  { "Southern Veracruz": { coords: [-94.379273, 17.301213], code: "mx" } },
  { Southwest: { coords: [-109.045167, 36.998972], code: "us" } },
  {
    Spitalfields: { coords: [-8.66447010999997, 52.2440153420001], code: "gb" },
  },
  { "Sri Lanka": { coords: [80.698632418, 7.61767840900006], code: "lk" } },
  {
    "St. Johnsbury": {
      coords: [-72.0207799999999, 44.4182300000001],
      code: "us",
    },
  },
  {
    Staffordshire: {
      coords: [-2.03690073199994, 52.8577185550001],
      code: "gb",
    },
  },
  {
    Stirling: { coords: [-3.93946999999997, 56.1173400000001], code: "gb-sct" },
  },
  { "Stoke on Trent": { coords: [-2.17503999999997, 53.02993], code: "gb" } },
  {
    Stourbridge: { coords: [-2.14780999999994, 52.4542500000001], code: "gb" },
  },
  { Strasburg: { coords: [7.73642000000007, 48.58504], code: "fr" } },
  { Sultanabad: { coords: [49.6891600000001, 34.0917400000001], code: "ir" } },
  { Swat: { coords: [72.483333, 35.2], code: "pk" } },
  { Switzerland: { coords: [8.24502409600007, 46.7998174420001], code: "ch" } },
  { Syracuse: { coords: [15.28133, 37.0780100000001], code: "it" } },
  { Syria: { coords: [38.505273339, 35.012808546], code: "sy" } },
  { "Tamil Nadu": { coords: [78.40968946, 11.0132498300001], code: "in" } },
  { Taranto: { coords: [17.2505400000001, 40.4653700000001], code: "it" } },
  { Tarentum: { coords: [-79.75192, 40.60096], code: "us" } },
  { Tennessee: { coords: [-86.3430511769999, 35.843002697], code: "us" } },
  { Thailand: { coords: [101.012239206, 15.116802787], code: "th" } },
  { Thásos: { coords: [24.70944, 40.77806], code: "" } },
  { Thebes: { coords: [-89.4609, 37.2210400000001], code: "" } },
  { Thessaly: { coords: [21.98364, 39.4022400000001], code: "" } },
  { Tibet: { coords: [90.0000000000001, 32.0000000000001], code: "" } },
  { Tlapacoyan: { coords: [-97.21664, 19.9627], code: "mx" } },
  { Tlatilco: { coords: [-99.16493, 19.4573], code: "mx" } },
  { Trier: { coords: [6.63629000000003, 49.7573400000001], code: "de" } },
  { Turkey: { coords: [35.142286272, 39.066250645], code: "tr" } },
  { Tyre: { coords: [35.20016, 33.2705700000001], code: "lb" } },
  { Umbria: { coords: [12.495426185, 42.9633352110001], code: "it" } },
  {
    "United Kingdom": { coords: [-1.96955954399993, 53.408386605], code: "gb" },
  },
  { "United States": { coords: [-95.712891, 37.09024], code: "us" } },
  { Usumacinta: { coords: [-91.49326, 17.5532700000001], code: "" } },
  { "Uttar Pradesh": { coords: [80.5636918490001, 26.928766474], code: "in" } },
  { Uzbekistan: { coords: [63.4218830140001, 41.581345637], code: "uz" } },
  {
    Valenciennes: { coords: [3.52411000000006, 50.3584700000001], code: "fr" },
  },
  { "Valley of Mexico": { coords: [-98.866667, 19.666667], code: "mx" } },
  { Velia: { coords: [-2.21666999999997, 12.0000000000001], code: "" } },
  { "Venado Beach": { coords: [-81.43333, 8.10000000000002], code: "pa" } },
  { Venice: { coords: [-118.47215, 33.98754], code: "it" } },
  { "Veracruz Llave": { coords: [-96.383333, 19.433333], code: "mx" } },
  { "Veracruz state": { coords: [-96.383333, 19.433333], code: "mx" } },
  { "Veracruz, south central": { coords: [-94.91211, 17.954308], code: "mx" } },
  { "Veracruz, southern": { coords: [-94.379273, 17.301213], code: "mx" } },
  { "Veraguas, Provincia de": { coords: [-81, 8], code: "pa" } },
  { Veramin: { coords: [51.6377900000001, 35.3391100000001], code: "ir" } },
  { Vienna: { coords: [16.3684200000001, 48.2026300000001], code: "at" } },
  { Vietnam: { coords: [107.83333, 16.1666700000001], code: "vn" } },
  { "Villalcázar de Sirga": { coords: [-4.533333, 42.316667], code: "es" } },
  { Vulci: { coords: [15.70083, 45.2380600000001], code: "" } },
  { Wales: { coords: [-3.76522175999997, 52.3371513180001], code: "gb-wls" } },
  { Washington: { coords: [-120.5, 7.5], code: "us" } },
  {
    "Washington Street, 59 West": {
      coords: [-87.629791, 41.883216],
      code: "us",
    },
  },
  { Welsh: { coords: [-3.76522175999997, 52.3371513180001], code: "gb-wls" } },
  { "Western Europe": { coords: [6.367163, 49.496192], code: "" } },
  { "Western Mexico": { coords: [-103.683333, 20.566667], code: "mx" } },
  { "Western Tibet": { coords: [81.454362, 33.612838], code: "" } },
  { "White Mountain": { coords: [-108.8518, 35.06858], code: "" } },
  { Wisconsin: { coords: [-89.739185424, 44.644833367], code: "us" } },
  { Woodstock: { coords: [-72.51764, 43.6253800000001], code: "us" } },
  { Worcester: { coords: [-2.17503999999997, 53.02993], code: "gb" } },
  { "Yucatan Peninsula": { coords: [-89.2, 19.366667], code: "mx" } },
  { Bethlehem: { coords: [35.195556, 31.703056], code: "" } },
  { Chicago: { coords: [-87.623177, 41.881832], code: "us" } },
  { Crowleytown: { coords: [-74.617778, 39.628333], code: "us" } },
  { England: { coords: [-1.17432, 52.355518], code: "gb" } },
  { Florida: { coords: [-80.2, 26.133333], code: "us" } },
  { Germany: { coords: [10.451526, 51.165691], code: "de" } },
  { Iran: { coords: [53.6880455, 32.4279099], code: "ir" } },
  { "New York": { coords: [-75, 43], code: "us" } },
  { Norway: { coords: [8.468946, 60.472023], code: "no" } },
  { Paris: { coords: [2.352222, 48.856613], code: "fr" } },
  { Pennsylvania: { coords: [-77.194527, 41.203323], code: "us" } },
  { Persia: { coords: [53.6880455, 32.4279099], code: "" } },
  { "Saint Petersburg": { coords: [30.308611, 59.9375], code: "ru" } },
  { Scotland: { coords: [-4.2026458, 56.4906712], code: "gb-sct" } },
  { Spain: { coords: [-3.74922, 40.463669], code: "es" } },
  { Spanish: { coords: [-3.74922, 40.463669], code: "es" } },
  { Sweden: { coords: [16.325556, 62.3875], code: "se" } },
];
